// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".el-select-dropdown__item {\n  height: auto !important;\n}", "",{"version":3,"sources":["D:/source/200xth/xth2.web/<input css 5>"],"names":[],"mappings":"AAAA;EACE,uBAAuB;AACzB","file":"customerSelector.vue","sourcesContent":[".el-select-dropdown__item {\n  height: auto !important;\n}"]}]);
// Exports
module.exports = exports;
